module.exports = __webpack_public_path__ + "static/practice-03-cover-08008428ac0d321024a2e92240d6d866.jpg";